module.exports = __webpack_public_path__ + "img/hr-splitter-south.63c7f837.png";